import { graphql } from '@/gql'

export const SYSTEM_FIELDS_QUERY = graphql(`
  query systemFields(
    $filter: SystemFieldFilter
    $locale: String
    $getUserData: Boolean!
    $userIds: [UUID!]
  ) {
    systemFields(filter: $filter) {
      edges {
        node {
          id
          name
          type
          readableName
          localizedName
          readOnly
          documentTemplatePlaceholderName
          excludeFromPlaceholderForm
          alwaysRequired
          userSystemFields(filter: { userId: { in: $userIds } })
            @include(if: $getUserData) {
            nodes {
              data
              humanReadableValue
              userId
            }
          }
          companySystemField {
            id
            sensitive
            changesMustBeApproved
            supportsFutureData
            required
            defaultValue
            fieldGroupId
            fieldGroup {
              id
              localizedName
            }
            metadata
            localizedAlias
            localizedHelpText
            companySystemFieldOptions(
              orderBy: ORDER_ASC
              condition: { active: true }
            ) {
              nodes {
                id
                value
                localizedValue(locale: $locale)
              }
            }
          }
        }
      }
    }
  }
`)

export const COMPANY_SYSTEM_FIELD_QUERY = graphql(`
  query companySystemField($id: UUID!) {
    companySystemFieldById(id: $id) {
      id
      sensitive
      changesMustBeApproved
      approverUserIds
      approverGroupIds
      approverSystemFieldIds
      approverFormFieldIds
      supportsFutureData
      required
      metadata
      defaultValue
      fieldGroupId
      alias
      aliasTranslatedEntity {
        ...TranslatedEntityLocalizations
      }
      helpText
      helpTextTranslatedEntity {
        ...TranslatedEntityLocalizations
      }
      excludedRoleIds
      systemField {
        id
        name
        readableName
      }
      companySystemFieldOptions(
        orderBy: ORDER_ASC
        condition: { active: true }
      ) {
        nodes {
          id
          order
          value
        }
      }
    }
  }
`)

export const SYSTEM_FIELD_OPTIONS_QUERY = graphql(`
  query companySystemFieldOptions {
    companySystemFieldOptions(condition: { active: true }) {
      edges {
        node {
          id
          value
        }
      }
    }
  }
`)

export const JOB_POSITION_TYPE_OPTIONS = graphql(`
  query jobPositionTypeOptions {
    companySystemFieldOptions(
      filter: {
        active: { equalTo: true }
        companySystemField: {
          systemField: { name: { equalTo: "job_position_type" } }
        }
      }
    ) {
      edges {
        node {
          id
          name: localizedValue
        }
      }
    }
  }
`)

export const JOB_POSITION_WORKING_HOURS_OPTIONS = graphql(`
  query jobPositionWorkingHoursOptions {
    companySystemFieldOptions(
      filter: {
        active: { equalTo: true }
        companySystemField: {
          systemField: { name: { equalTo: "job_position_working_hours" } }
        }
      }
    ) {
      edges {
        node {
          id
          name: localizedValue
        }
      }
    }
  }
`)

export const USER_SYSTEM_FIELD_COUNT = graphql(`
  query userSystemFieldCount($employeeIds: [UUID]!) {
    userSystemFieldCount(argEmployeeIds: $employeeIds) {
      nodes {
        count
        value
      }
    }

    userDepartmentCount(argEmployeeIds: $employeeIds)
  }
`)

export const USER_SYSTEM_FIELDS = graphql(`
  query userSystemFields(
    $id: UUID!
    $companyId: UUID!
    $employeeIds: [UUID!]!
  ) {
    userSystemFields(
      filter: {
        companyId: { equalTo: $companyId }
        systemFieldId: { equalTo: $id }
        data: { isNull: false, notEqualTo: { value: null } }
        user: {
          active: { equalTo: true }
          employeeByUserId: { id: { in: $employeeIds } }
        }
      }
    ) {
      nodes {
        systemFieldId
        userId
        data
      }
    }
  }
`)
